const date = new Date();
const year = date.getFullYear();

const APPCONFIG = {
  brand: 'AloSeguro',
  user: 'Juan',
  year,
  productLink: 'https://aloseguro.com',
  AutoCloseMobileNav: true,                         // true, false. Automatically close sidenav on route change (Mobile only)
  color: {
    primary: '#031248',
    success: '#8BC34A',
    info: '#66BB6A',
    infoAlt: '#7E57C2',
    warning: '#FFCA28',
    danger: '#F44336',
    text: '#031248',
    gray: '#EDF0F1'
  },
  cyber_merchant: "tc_pa_016026439",
  cyber_payment_environment: "test",//live,test
  settings: {
    layoutBoxed: false,                             // true, false
    navCollapsed: true,                            // true, false
    navBehind: false,                               // true, false
    fixedHeader: false,                              // true, false
    sidebarWidth: 'middle',                         // small, middle, large
    colorOption: '22',                              // String: 11,12,13,14,15,16; 21,22,23,24,25,26; 31,32,33,34,35,36
    theme: 'light',                                 // light, gray, dark
    escompleta: false,
    dtercero: false,                                 
  }
};

module.exports = APPCONFIG;



// WEBPACK FOOTER //
// ./constants/Config.js